module.exports = __webpack_public_path__ + "static/media/4.cf980351.jpg";